export default (minutes) => {
	const hours = Math.floor(minutes / 60);
	const restMinutes = minutes - hours * 60;
	if (hours > 0) {
		return `${hours} ч. ${restMinutes} минут`;
	}
	return `${restMinutes} минут`;
};
